export default {

  floatRight :  {
    float: 'right'
  },

   table : {
    background: "#fff",
    padding: "10px",
    position: "absolute",
    width: "76%",
    cellSpacing: "40px",
    top: "300px",
    textAlign: "center",
    margin: "30px",


  },
  courseTable: {
    background: "#fff",
    padding: "10px",
    position: "absolute",
    width: "76%",
    cellSpacing: "40px",
    top: "130px",
    textAlign: "center",
    margin: "30px",


  },

  sectionTable : {
    background: "#fff",
    padding: "10px",
    //position: "absolute",
    width: "95%",
    cellSpacing: "40px",
   // top: "115px",
    textAlign: "center",
    margin: "30px",


  },


  quizScoreTable : {
    background: "#fff",
    padding: "10px",
    position: "absolute",
    width: "76%",
    cellSpacing: "40px",
    top: "115px",
    textAlign: "center",
    margin: "30px",


  },

  subjectTable : {
    background: "#fff",
    padding: "10px",

    width: "100%",
    cellSpacing: "40px",
    top: "112px",
    textAlign: "center",
    margin: "30px",


  },
  topicTable : {
    background: "#fff",
    padding: "10px",
    width: "90%",
    cellSpacing: "40px",
    top: "112px",
    textAlign: "center",
    margin: "30px",


  },
  subCatTable : {
    background: "#fff",
    padding: "10px",
    //position: "absolute",
    width: "96%",
    cellSpacing: "40px",
     top: "160px",
    textAlign: "center",
    margin: "30px",


  },
  catTable : {
    background: "#fff",
    padding: "10px",
    width: "96%",
    cellSpacing: "40px",
    top: "162px",
    textAlign: "center",
    //margin: "30px",
    marginLeft: "32px",
    marginTop: "62px",


  },
   title : {
    padding: "10px",
    background: "#fff",
    fontSize : "20px",
    position: "absolute",
    top: "238px",
    color: '#576271',
    width: "76%",
    height: "50px",
    // fontWeight: "bold",
    margin: "30px",

  },
  courseTitle : {
    padding: "10px",
    background: "#fff",
    fontSize : "20px",
    position: "absolute",
    top: "62px",
    color: '#576271',
    width: "76%",
    height: "50px",
    // fontWeight: "bold",
    margin: "30px",

  },
  sectionDashboardTitle : {
    padding: "8px",
    background: "#fff",
    fontSize : "20px",
    position: "absolute",
    top: "37px",
    color: '#576271',
    width: "76%",
    height: "42px",
    // fontWeight: "bold",
    margin: "24px",

  },
  titleStyle : {
    padding: "10px",
    background: "#fff",
    fontSize : "20px",
    position: "absolute",
    top: "60px",
    color: '#576271',
    width: "76%",
    height: "50px",
    // fontWeight: "bold",
    margin: "30px",

  },
  sectionTitle : {
    padding: "10px",
    background: "#fff",
    fontSize : "20px",
    // position: "absolute",
    // top: "60px",
    color: '#576271',
    width: "95%",
    height: "50px",
    // fontWeight: "bold",
    margin: "30px",

  },

  subjectTitle : {
    padding: "10px",
    background: "#fff",
    fontSize : "20px",
    top: "60px",
    color: '#576271',
    width: "100%",
    height: "50px",
    // fontWeight: "bold",
    margin: "30px",

  },
  topicTitle : {
    padding: "10px",
    background: "#fff",
    fontSize : "20px",
    top: "60px",
    color: '#576271',
    width: "90%",
    height: "50px",
    // fontWeight: "bold",
    margin: "30px",

  },
  catTitle : {
    padding: "10px",
    background: "#fff",
    fontSize : "20px",
    //top: "65px",
    color: '#576271',
    width: "96%",
    height: "50px",
    // fontWeight: "bold",
    marginLeft: "29px",
    marginTop: "100px",

  },
   breadcrumb : {
     li:{
          style:{
          display: "inline-block",
          marginBottom:"0.001px",
          marginTop:"0.001px",
          listStyle: "none",
          overflow: "hidden",
          color:"#bb0000"
          },
          itemNameSpan:{
          style:{
          color:"#bb0000",
          fontfamily:"Roboto",
          fontSize : "15px",
          fontWeight: 'bold'
          }
          },
          itemTypeSpan:{
          style:{
          fontfamily:"Roboto",
          fontSize : "10px",
          fontWeight: 'normal',
          fontStyle: 'italic',
          paddingLeft:"10px"
           }
          }
  }
},
 li : {
    float: "left",
    fontSize : "17px"

},
 segemntStyle : {
  margin: '30px',
  position: "absolute",
  top: "105px",
  width: "177px",
},
categorySegemntStyle : {
  //margin: '30px',
  marginLeft: "-10px",
  position: "absolute",
  width: "176px",
  //top: "105px",

},
subcategorySegemntStyle : {
  margin: '30px',
  position: "absolute",
  top: "105px",
  width: "272px",

},

subcategoryDetailsSegemntStyle : {
  margin: '30px',
  position: "absolute",
  top: "105px",
  width: "176px",

},
 addButton : {

        backgroundColor: '#005200', /* Green */
        border: 'none',
        color: 'white',
        padding: '10px 20px',
        textAlign: 'center',
        fontSize: '13px'

  },

  operationButton : {
    backgroundColor: 'white',
    color: 'rgb(255,190,0)',
    fontSize: '18px',
    width: '60px',
    height: '30px',
    /* fontWeight: 'bold', */
    fontFamily: 'inherit'
  },

  calciScreen : {
    width: 'auto',
    color: 'black',
    fontSize: '22px',
    marginLeft: '4%',
/*     marginRight: '4%',
    marginLeft: '2%' */
    // paddingLeft: '21%',
    
  },

  calciTableStyle: {
    // paddingTop: '10%'
    borderCollapse: 'separate',
    borderSpacing: '0 15px',
  },

  screenDiv: {
    // paddingLeft: '4%'
    // marginLeft: '4%'
  },

  equalToButton : {
    backgroundColor: 'rgb(255,190,0)',
    color: 'white',
    fontSize: '16px',
    width: '55px',
    height: '30px',
    fontWeight: 'bold',
    fontFamily: 'inherit'
  },

  numberButton : {
    backgroundColor: 'white',
    color: 'black',
    fontSize: '16px',
    width: '55px',
    height: '30px',
    fontFamily: 'inherit'
  },

  calciDialog: {
    width: 'auto'
  },

  calciButton: {
    backgroundColor: 'grey',
    color: 'white'
  },

  disabledButton : {
        backgroundColor: '#dddddd',
        border: 'none',
        color: 'black',
        padding: '10px 20px',
        textAlign: 'center',
        fontSize: '13px'
  },

  cancelButton : {

        backgroundColor: '#e01a00', /* Green */
        border: 'none',
        color: 'white',
        padding: '10px 20px',
        textAlign: 'center',
        fontSize: '13px'

  },
  thead : {
    borderBottom : "0.02px solid grey",
    color: '#576271',
    fontSize : "20px"
  },
  td : {
    color: '#576271'
  },
  quizTd : {
    color: '#576271',
    borderBottomStyle:"groove",

  },

  tableCursorTd : {
    color: '#576271',
    cursor: "pointer",
  },
  profileContainer:{
    paddingTop : "10px",
    paddingBottom : "90px",
  }
  ,
  picContainer : {
    width: '30%',
    float: 'left',
  },
  avatar : {
    WebkitBorderRadius: "50%",
    height: "60px",
    MozBorderRadius: "10%",
    borderRadius: "50%",
  },
  profileTextContainer:{
    width: '65%',
    float: 'right',
    textAlign:'left'
  },
  instructortable:{
    width: "100%"
  },

  instructorData : {

  },
  instructor : {
    fontFamily:"Roboto",
    color: "white",
    fontSize:"large",
    fontWeight:"bold",
    marginBottom:'0px'
  },
   instructorName: {
    fontFamily:"Roboto",
    color: "white",
    marginBottom:'0px',
    marginLeft:'2px'
  },
  university : {
    fontFamily:"Roboto",
    fontWeight : "8px",
    color: "white",
    marginBottom:'0px',
    marginLeft:'2px'
  },logout : {
    fontFamily:"Roboto",
    fontWeight : "5px",
    marginBottom:'0px',
    marginLeft:'2px',
  },
  logout_button: {
    fontFamily: 'Roboto',
    fontWeight: '5px',
    marginBottom: '0px',
    marginLeft: '2px',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  univName: {
    fontSize: "1.6rem",
    fontWeight:"bold",
    color:"#fff",
    padding:"0.3rem 0.5rem",
    lineHeight:"2rem",
    textAlign:"center"
  },
  navigationHeader : {
    width : "100%",
    background:'#666666',
    margin: 'auto',
    textAlign: 'center'
  },
  SegmentedControl : {
    position: "relative",
     width: '550%',
     color: '#bb0000',
     backgroundColor:'white',
     borderColor:'#95989A',
     borderWidth: '0.5px'
  },
  categorySegmentedControl : {
    position: "relative",
     width: '550%',
     color: '#bb0000',
     backgroundColor:'white',
     borderColor:'#95989A',
     borderWidth: '0.5px',
     height:"45px",
     fontSize:"16px",
  },
  SegmentedControlCatDetails : {
    position: "relative",
     width: '355%',
     color: '#bb0000',
     backgroundColor:'white',
     borderColor:'#95989A',
     borderWidth: '0.5px'
  },
  createQuesPage : {
    background: "#fff",
    //width: "95%",

    margin: "8px",
    marginTop:"0px",
    zIndex: "-1",
  },
  select :  {

    width: "210px",
    // height:"30px",
    // marginLeft:"36px",
    // borderRadius: "0px",
    // marginTop: "35px"

  },
  choice:{
    width: "210px",
    height:"29px",
    borderRadius: "0px",

    marginLeft:"16px",
    marginTop: "8px"
  },
  livePreview : {
    backgroundColor: "#960000",
    marginTop: "35px",
    marginLeft:"16px",
    marginRight:"30px",
    float: "right",
    height:"50px",
    border: "none",
    //position: "relative",
    color: "white",
    width:"110px",
    textAlign : "top",
    textDecoration: "none",
    // display: "inline-block",
    fontSize: "13px",
    // margin: "4px 30px",
    cursor: "pointer",

  },
  topic : {

    width: "400px",
    height: "41px",
    border: "none",
    fontSize: "16px",
    color: '#576271',
    paddingLeft: "17px",
    // height:"30px",
    // marginTop:"35px",
    // marginLeft:"16px",



  },
  questionNameText : {

        width: "300px",
        height: "41px",
        fontSize: "16px",
        backgroundColor: "#d4e7f5",
        border: "1px solid rgb(250,250,250)",
        borderRadius: "3px 3px 3px 3px",
        opacity: "1",
        paddingLeft: "17px",
        marginLeft: "17px",

      },
  switch : {
    marginLeft:"90dp"
  },
  randamizeOrder : {
  //  marginLeft : "20px",
    width:"15px",
    height:"30px",
    //position: "relation",
    marginTop:"15px",


  },
  randamizeOrderLable : {
    //marginLeft:"86px",
    position: "relative",
    marginTop:"5",
    textAlign: "centre",
    color: '#576271',
    paddingLeft:"10px",
    fontSize: "14px",

  },
  imageLibrary : {
    //marginLeft:"216px",
    //position: "absolute",
    marginTop:"14px",
  },
  imageLibraryLable : {
    // marginLeft:"256px",
    // position: "absolute",
    color: '#576271',
    marginTop:"16",
  },
  questionTextLabel : {
    // marginLeft:"356px",
    // position: "absolute",
    color: '#576271',
    marginTop:"16",


  },
  questionBelowAboveDiv : {
    // paddingTop: "16px",
    // marginLeft: "450px",
    // position: "absolute",
     color: '#576271',

  },
  questionBelowAboveButton : {

  },
  TextEditor:{
   // position: "absolute",
    //marginLeft:"16px",
    float:"left",
    width:"500px",
    //height: "154px",
    //marginTop: "30px"
  },
  dropzoneComponent : {
    float:"left",
    //paddingTop: "16px",
    paddingLeft: "10px",
    //position: "absolute",
    //marginLeft: "720px",
    //color: '#576271',
     paddingTop: "13px",
    //marginTop: "-37px",
    color: 'rgb(127, 102, 113)',


  },
  bodyBGStyle : {
    backgroundColor: "#FAFAFA",
    //overflow: "hidden"
  },
  quesWidthHeight : {
    float:"left",
    paddingTop: "13px",
    paddingLeft: "5px",
    // position: "absolute",
    //marginLeft: "880px",
   // marginTop: "-37px",
    color: 'rgb(127, 102, 113)',
  },
  quesWidth : {
    marginLeft: "5px",
  },
  imageLibraryButton : {

    backgroundColor: "#960000",

    height:"30px",
    border: "none",
    color: "white",
    width:"110px",
    textAlign : "top",
    textDecoration: "none",
    // display: "inline-block",
    fontSize: "13px",
    lineHeight: "7px",
    // margin: "4px 30px",
    cursor: "pointer",

  },
  addAnswer : {
    float: "left",
    marginRight: "20px",



  },
  addAnswerLable : {
    color: 'rgb(127, 102, 113)',
    //marginTop: "17px",
    float:"left",
  },
  answerButton : {

    backgroundColor: "#960000",

    height:"30px",
    border: "none",
    color: "white",
    width:"100%",
    textAlign : "top",
    textDecoration: "none",
    // display: "inline-block",
    fontSize: "13px",
    lineHeight: "7px",
    // margin: "4px 30px",
    cursor: "pointer",

  },
  correctAnswer : {
    //position:"absolute",
    color: 'rgb(127, 102, 113)',
    marginTop: "6px",
    marginLeft: "8px",

  },
  correctAnswerSwitch : {
    //position:"absolute",
    marginTop: "6px",
  },
  deleteAnswerButton : {

    backgroundColor: "#bb0000",
    height:"30px",
    borderRadius: "8px",
    marginTop: "6px",
    color: "white",
    textAlign : "top",
    textDecoration: "none",
    // display: "inline-block",
    fontSize: "13px",
    lineHeight: "7px",
    // margin: "4px 30px",
    cursor: "pointer",
    float: 'right'
  },
  previewDiv :{
    width:"50%",
    height:"700px",
    marginTop:"0px",
    marginRight:"0px",
    backgroundColor: "red",

  },
  buttomClass : {
    backgroundColor: "#bb0000",
    height:"30px",
    border: "none",
    color: "white",
    width:"110px",
    //textAlign : "top",
    textDecoration: "none",
    // display: "inline-block",
    fontSize: "13px",
    //lineHeight: "7px",
    // margin: "4px 30px",
    cursor: "pointer",

  },

  livePreviewTitleDiv : {
    marginTop: "10px",
    position:  "relative",

  },

  previewTitle : {
    float: "left",
    fontSize:"20px",
    fontWeight:"600",
    marginLeft:"200px"
  },
  livePreviewQuestionDiv : {
    marginTop: "60px",
    position:  "relative"
  },
  previewText : {
    marginLeft:"30px",
    fontSize:"20px",

  },
  imageLibraryTextAlign : {
    float: "left",
    marginTop: "-5px",
    paddingLeft: "10px",
    fontSize:"14px",
},
imageLibraryAlign : {
  float: "left",

},
drawerTitleText : {
  color: "white",
  fontSize: 'large',
  paddingTop:'5%',
  paddingBottom:'5%',
  fontFamily:"Roboto",
  textAlign: 'center',
  minHeight: '65px',
},
drawerTitleColor : {
  backgroundColor: '#bb0000',
  paddingLeft:'2px',
  paddingTop:'2px'
},

}
